import { TreeSelect as AntdTreeSelect } from 'antd';
import Label from '../label';
import SelectChip from '../select/select-chip';
import { FaChevronDown } from 'react-icons/fa6';
import styles from '../select/index.module.scss';
import ErrorMessage from '../error-message';
import Skeleton from '../skeleton';

const TreeSelect = ({
  style = {},
  placeholder = '',
  options = [],
  value,
  onClear,
  allowClear = true,
  onChange = () => {},
  multiple = false,
  dropDownStyle = {},
  checkable = false,
  label = '',
  required = true,
  size = 'large',
  errorMsg = '',
  loading = false,
  highlightSearch = false,
  treeDefaultExpandedKeys = [],
}) => {
  const highlightSearchText = (searchText, targetText) => {
    if (!searchText || !targetText || !highlightSearch) {
      return targetText;
    }
    const index = targetText.toLowerCase().indexOf(searchText.toLowerCase());
    if (index === -1) {
      return targetText;
    }
    const beforeStr = targetText.substring(0, index);
    const matchStr = targetText.substring(index, index + searchText.length);
    const afterStr = targetText.substring(index + searchText.length);
    return (
      <span>
        {beforeStr}
        <span style={{ backgroundColor: '#D3D3D3', fontWeight: 'bold' }}>{matchStr}</span>
        {afterStr}
      </span>
    );
  };
  return (
    <div>
      {label && <Label required={required}>{label}</Label>}
      <div>
        {loading ? (
          <Skeleton height={40} />
        ) : (
          <AntdTreeSelect
            style={style}
            className={styles.select}
            placeholder={placeholder}
            treeData={options}
            value={value}
            onClear={onClear}
            filterTreeNode={(input, option) => {
              return option?.title?.toLowerCase()?.includes(input?.trim()?.toLowerCase());
            }}
            tagRender={SelectChip}
            allowClear={allowClear}
            onChange={(value, label, extra) => onChange(value, label, extra)}
            multiple={multiple}
            dropdownStyle={dropDownStyle}
            treeCheckable={checkable}
            showCheckedStrategy={checkable ? TreeSelect.SHOW_CHILD : undefined}
            suffixIcon={<FaChevronDown color="var(--gray-500)" />}
            size={size}
            maxTagCount={'responsive'}
            showSearch={true}
            status={errorMsg && 'error'}
            treeDefaultExpandedKeys={treeDefaultExpandedKeys}
            treeTitleRender={(nodeData) => {
              const searchValue = document.querySelector('.ant-select-selection-search-input')?.value || '';
              return highlightSearchText(searchValue, nodeData?.title);
            }}
          />
        )}
      </div>
      {errorMsg && <ErrorMessage errorMsg={errorMsg} />}
    </div>
  );
};

export default TreeSelect;
